(function () {
  // Push a GA4 event via window.gtag (direct tag) or window.dataLayer (GTM).
  // Shopify's native GA4 pixel is sandboxed, so window.gtag may not exist —
  // dataLayer is the reliable fallback when GTM is present.
  function trackEvent(eventName, params) {
    // Debug trail, readable from the console as window.__ga4Debug. Tells apart
    // "the listener never ran" from "it ran but the event went nowhere", which
    // is otherwise invisible: everything below fails silently by design.
    try {
      window.__ga4Debug = window.__ga4Debug || [];
      window.__ga4Debug.push({ event: eventName, params: params, at: new Date().toISOString() });
    } catch (e) {}

    try {
      if (typeof window.gtag === 'function') {
        window.gtag('event', eventName, Object.assign({ transport_type: 'beacon' }, params));
        return;
      }
      // The array is CREATED when missing, not just used when it happens to be
      // there. The SEO app defers every googletagmanager.com script until the
      // first keydown, mousemove, touchstart, touchmove, touchend or wheel (see
      // snippets/avada-seo-other.liquid), so on a click that lands before that
      // the container has not run and window.dataLayer does not exist yet.
      // Pushing into an array we create is the documented GTM contract: the
      // container replays whatever is already queued when it initialises. Only
      // using an existing array dropped those events for good — and it is not
      // what the rest of the theme does (native-imm.js, outfit-page.js both
      // queue).
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push(Object.assign({ event: eventName }, params));
    } catch (e) {}
  }

  function productTitle() {
    var titleEl = document.querySelector('h1');
    return titleEl ? titleEl.textContent.trim() : document.title;
  }

  // ── Size-help entry points on the product page ────────────────────────────
  // Two buttons, two separate events, so the reports can say which one
  // shoppers actually reach for:
  //   #sc-btn  "Guida alle taglie"                 (snippets/size-chart-button.liquid)
  //   #sz-btn  "Non sei sicuro della tua taglia?"  (liquid block in templates/product.json)
  //
  // Wired here by id and delegated from document rather than inline next to
  // each button, for two reasons. The recommender button lives in
  // templates/product.json, which the theme deploy deliberately ignores — the
  // editor owns that file, so a change to it in git would never ship. And both
  // buttons stay hidden until a backend call confirms a size chart matches the
  // product, so neither is clickable when this script runs.
  var SIZE_HELP_BUTTONS = [
    { selector: '#sc-btn', event: 'size_guide_open' },
    { selector: '#sz-btn', event: 'size_recommender_open' },
  ];

  document.addEventListener('click', function (e) {
    if (!e.target || typeof e.target.closest !== 'function') return;
    for (var i = 0; i < SIZE_HELP_BUTTONS.length; i++) {
      var entry = SIZE_HELP_BUTTONS[i];
      // closest() and not e.target: one button wraps its label in a span, the
      // other in an svg, so the click lands on the child.
      if (e.target.closest(entry.selector)) {
        trackEvent(entry.event, { product_title: productTitle() });
        return;
      }
    }
  });

  // ── Color swatch clicks on collection cards ───────────────────────────────
  document.addEventListener('click', function (e) {
    var link = e.target.closest('.card-color-swatches__link');
    if (!link) return;

    var color = link.getAttribute('aria-label') || link.getAttribute('title') || '';
    var card = link.closest('product-card, .product-card, .sp-card');
    var titleEl = card ? card.querySelector('[class*="product-card__title"], [class*="card__title"], .sp-card__title') : null;
    var productTitle = titleEl ? titleEl.textContent.trim() : document.title;
    var productUrl = link.getAttribute('href') || '';

    trackEvent('select_color_swatch', {
      color: color,
      product_title: productTitle,
      product_url: productUrl,
    });
  });

  // ── Variant option selection on product page ──────────────────────────────
  document.addEventListener('change', function (e) {
    var input = e.target;
    if (!input || input.type !== 'radio') return;
    var fieldset = input.closest('fieldset.variant-picker__option');
    if (!fieldset) return;

    var optionName = '';
    var legend = fieldset.querySelector('legend');
    if (legend) optionName = legend.textContent.trim();

    var label = input.id ? document.querySelector('label[for="' + input.id + '"]') : null;
    var optionValue = label ? label.textContent.trim() : (input.value || '');

    var titleEl = document.querySelector('h1');
    var productTitle = titleEl ? titleEl.textContent.trim() : document.title;

    trackEvent('select_variant_option', {
      option_name: optionName,
      option_value: optionValue,
      product_title: productTitle,
    });
  });

  // Also listen for the custom event some theme components dispatch
  document.addEventListener('on:variant:change', function (e) {
    var variant = e.detail && e.detail.variant;
    if (!variant) return;
    var titleEl = document.querySelector('h1');
    trackEvent('select_variant_option', {
      option_name: 'variant',
      option_value: variant.title || '',
      product_title: titleEl ? titleEl.textContent.trim() : document.title,
    });
  });
})();
